module.exports = __webpack_public_path__ + "static/img/e-commerce-basket-laptop.d5100eee.svg";